export default "__VITE_ASSET__BdHtc71K__"